import { useStores, type WebhookEndpoint } from '@littlebird/sdk';
import { useEffect, useState } from 'react';

export type WebhookEndpointSetup =
  | { status: 'loading' }
  | { status: 'missing' }
  | { status: 'found'; endpoint: WebhookEndpoint };

/** The endpoint a setup link in chat names, fetched fresh so a secret set elsewhere shows. */
export function useWebhookEndpointSetup(
  endpointId: string
): WebhookEndpointSetup {
  const { routines } = useStores();
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    let current = true;
    // The store logs a failure; the card then says it can't find the endpoint
    routines
      .fetchWebhookEndpoints()
      .catch(() => {})
      .finally(() => {
        if (current) setFetched(true);
      });
    return () => {
      current = false;
    };
  }, [routines]);

  const endpoint = routines.webhookEndpoints.find((e) => e.id === endpointId);
  if (endpoint) return { status: 'found', endpoint };
  return fetched ? { status: 'missing' } : { status: 'loading' };
}
